export type CountryCode = "au" | "nz";
export enum CountryCodeEnum {
  AU = "au",
  NZ = "nz",
}

export type KeyValue = {
  id: number;
  name: string;
};

export type CommitmentKeyValueEnum = KeyValue & {
  type: CommitmentEnum | null;
};

export interface FriendlyKeyValueUrl extends KeyValue {
  friendlyName: string;
  url: string;
}

export interface MetaSegment<T = number | string> {
  name: string;
  url: string;
  value: T;
}

type CommitmentEnum = EnumerationType & CommitmentEnumerationType;

type EnumerationType = {
  value: number;
  name: string;
};

type CommitmentEnumerationType = {
  isEvent: boolean;
  isShort: boolean;
  isRegularShort: boolean;
  isRegularLong: boolean;
};
